// top level tags
export const TAG_TEXT = "inno:text";
export const TAG_IMAGE = "inno:image";
export const TAG_MATH = "inno:math";
export const TAG_TABLE = "inno:table";

// many tags have ID attributes
export const ATTR_ID = "id";

// blocks represent visual rectangles that contain content
export const TAG_BLOCK = "inno:block";
export const ATTR_PAGE = "page";
export const ATTR_MIN_X = "x-min";
export const ATTR_MAX_X = "x-max";
export const ATTR_MIN_Y = "y-min";
export const ATTR_MAX_Y = "y-max";

// text block markup tags
export const TAG_BREAK = "inno:br";
export const TAG_ITALICS = "inno:i";
export const TAG_BOLD = "inno:b";
export const TAG_UNDERLINE = "inno:u";
export const TAG_SUPERSCRIPT = "inno:sup";
export const TAG_SUBSCRIPT = "inno:sub";
export const TAG_TCY = "inno:tcy";
export const TAG_FONT = "inno:font";
export const ATTR_FONT_SIZE = "font-size";
export const TAG_COLOR = "inno:color";
export const ATTR_RGB = "rgb";
export const TAG_NON_EXTRACT = "inno:nec";

// table elements
export const TAG_ROW = "inno:tr";
export const TAG_COL = "inno:td";
export const ATTR_ROW = "row";
export const ATTR_COL = "col";
export const ATTR_ROWSPAN = "rowspan";
export const ATTR_COLSPAN = "colspan";
